import React, { useContext, useState } from 'react';
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../contex/AuthProvider';
import ScocialLogin from '../Share/SocialLogin/ScocialLogin';

const Login = () => {
    const { register, formState: { errors }, handleSubmit } = useForm();
    const { logIn, setUserType } = useContext(AuthContext);
    const [loginerror, setLoginerror] = useState('');
    const location = useLocation();
    const navigate = useNavigate();
    const from = location.state?.from?.pathname || '/';
    const handleLogin = data => {
        console.log(data);
        setLoginerror('');
        logIn(data.email, data.password, data.userType)
            .then(result => {
                const user = result.user;
                console.log(user);
                // setLoginUserEmat(data.email);
                TakeToken(data.email);

            })
            .catch(error => {
                console.error(error.message)
                setLoginerror(error.message)
            });

    }
    const TakeToken = email => {
        fetch(`https://assignment-12-server-beige.vercel.app/jwt?email=${email}`)
            .then(res => res.json())
            .then(data => {
                if (data.accessToken) {
                    localStorage.setItem('accessToken', data.accessToken);
                    fetch(`https://assignment-12-server-beige.vercel.app/usersType/${email}`).then(res => res.json()).then(data => {
                        console.log(data);
                        setUserType(data.userType)
                        navigate('/')
                    })

                }
            })
    }
    return (
        <div className="hero w-full my-16">
            <div className="hero-content gap-12 grid md:grid-cols-2 flex-col lg:flex-row">
                <div className="text-center lg:text-left ml-4">

                    <img className='w-3/4 ml-6' src='https://coincent.ai/images/login.png' alt="" />
                </div>
                <div className='h-[800px]  flex justify-center items-center'>
                    <div className=' w-96 p-7'>
                        <h2 className='text-center text-4xl'>Login</h2>
                        <form onSubmit={handleSubmit(handleLogin)}>


                            <div className="form-control w-full max-w-xs">
                                <label className="label"><span className="label-text">Email</span></label>
                                <input type="text" {...register("email", {
                                    required: "Email Address is required"
                                })} className="input input-bordered w-full max-w-xs" />
                                {errors.email && <p className='text-red-600'>{errors.email?.message}</p>}
                            </div>
                            <div className="form-control w-full max-w-xs">
                                <label className="label"> <span className="label-text">Password</span></label>
                                <input type="password" {...register("password", {
                                    required: "Password is required",
                                    minLength: { value: 6, message: 'Password must be 6 characters or longer' }
                                })} className="input input-bordered w-full max-w-xs" />
                                {errors.password && <p className='text-red-600'>{errors.password?.message}</p>}
                                <label className="label"> <span className="label-text">Forget Password</span></label>

                            </div>

                            <input className='btn btn-accent w-full' value='Login' type="submit" />
                            {loginerror && <p className="text-red-500">{loginerror}</p>}
                        </form>
                        <p className='text-1xl mt-2'>New to Here ?<Link className='text-secondary' to='/signup'> Create a new Account</Link>
                        </p>
                        <div className="divider">OR</div>
                        <ScocialLogin></ScocialLogin>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;